import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Inspeccion30Y31Ano2024Politicas() {
  return <CategoryPage category="inspeccion30Y31Ano2024Politicas" pageTitle="Políticas" />;
}

export default Inspeccion30Y31Ano2024Politicas;
